import { render, staticRenderFns } from "./RequestNewPasswordView.vue?vue&type=template&id=0b613c9d&scoped=true&"
import script from "./RequestNewPasswordView.vue?vue&type=script&lang=js&"
export * from "./RequestNewPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./RequestNewPasswordView.vue?vue&type=style&index=0&id=0b613c9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b613c9d",
  null
  
)

export default component.exports